import {
  LuArrowLeft, LuArrowRight, LuBell, LuCalendar, LuCheck, LuClock,
  LuCreditCard, LuDollarSign, LuFacebook, LuHeart, LuInstagram,
  LuLayoutDashboard, LuLogIn, LuLogOut, LuMail, LuMapPin, LuMenu,
  LuMinus, LuPackage, LuPhone, LuPlus, LuSearch, LuSettings,
  LuShoppingBag, LuShoppingCart, LuStar, LuStore, LuTag,
  LuTrendingUp, LuTruck, LuTwitter, LuUser, LuUsers, LuX,
  LuPencil, LuTrash, LuEye, LuEyeOff, LuFilter, LuShield,
  LuShieldAlert, LuMessageSquare, LuFileText, LuBookOpen,
  LuInfo, LuShare2, LuCopy, LuLink, LuExternalLink, LuQrCode,
  LuCamera, LuLoader, LuRefreshCw, LuWrench, LuDatabase,
  LuCode, LuDownload, LuCrown, LuCornerDownRight, LuSend
} from 'react-icons/lu';
import {
  FiMoreVertical, FiAlertTriangle, FiAlertCircle, FiCheckCircle,
  FiHelpCircle, FiHome
} from 'react-icons/fi';
import { BiBeer } from 'react-icons/bi';

// Re-exporting all icons
export const ArrowLeft = LuArrowLeft;
export const ArrowRight = LuArrowRight;
export const BarChart2 = LuTrendingUp;
export const Bell = LuBell;
export const Calendar = LuCalendar;
export const Check = LuCheck;
export const CheckCircle = FiCheckCircle;
export const Clock = LuClock;
export const CreditCard = LuCreditCard;
export const DollarSign = LuDollarSign;
export const Facebook = LuFacebook;
export const Heart = LuHeart;
export const Instagram = LuInstagram;
export const LayoutDashboard = LuLayoutDashboard;
export const LogIn = LuLogIn;
export const LogOut = LuLogOut;
export const Mail = LuMail;
export const MapPin = LuMapPin;
export const Menu = LuMenu;
export const Minus = LuMinus;
export const Package = LuPackage;
export const Phone = LuPhone;
export const Plus = LuPlus;
export const Search = LuSearch;
export const Settings = LuSettings;
export const ShoppingBag = LuShoppingBag;
export const ShoppingCart = LuShoppingCart;
export const Star = LuStar;
export const Store = LuStore;
export const Tag = LuTag;
export const TrendingUp = LuTrendingUp;
export const Truck = LuTruck;
export const Twitter = LuTwitter;
export const User = LuUser;
export const Users = LuUsers;
export const X = LuX;
export const Edit = LuPencil;
export const Trash2 = LuTrash;
export const Eye = LuEye;
export const EyeOff = LuEyeOff;
export const Filter = LuFilter;
export const Beer = BiBeer;
export const Home = FiHome;
export const HelpCircle = FiHelpCircle;
export const BookOpen = LuBookOpen;
export const Info = LuInfo;
export const Share2 = LuShare2;
export const Copy = LuCopy;
export const Link = LuLink;
export const ExternalLink = LuExternalLink;
export const QrCode = LuQrCode;
export const Camera = LuCamera;
export const Loader = LuLoader;
export const RefreshCw = LuRefreshCw;
export const Wrench = LuWrench;
export const ShieldAlert = LuShieldAlert;
export const MoreVertical = FiMoreVertical;
export const AlertTriangle = FiAlertTriangle;
export const AlertCircle = FiAlertCircle;
export const Shield = LuShield;
export const MessageSquare = LuMessageSquare;
export const FileText = LuFileText;
export const Database = LuDatabase;
export const Code = LuCode;
export const Download = LuDownload;
export const Crown = LuCrown;
export const CornerDownRight = LuCornerDownRight;
export const Send = LuSend;